import React from "react";
import { BlockMath } from "react-katex";

function getLatexString(dividend, divisor) {
  let latexExpressionTemplate = `\\frac{\\text{\\textit{${dividend}}}}{\\text{\\textit{${divisor}}}}`;
  return latexExpressionTemplate;
}

const de = (
  <div>
    <p>Mit dieser Kennzahl soll ermittelt werden, wieviel Umsatz ein Mitarbeiter im Durchschnitt erzielt. Diese Kennzahl wird wie folgt berechnet:</p>
    <BlockMath>{getLatexString("Honorarumsatz", "Vollzeitstellen")}</BlockMath>
    <p className="sia-padding-01-bottom">Die Lernenden werden mit 15% gewichtet.</p>
    <p>
      Die Vollzeitstellen wurden aufgrund der erfassten Sollzeiten kalkulatorisch ermittelt. Dieses Berechnungsvorgehen ermöglicht ein akkurates
      Einbeziehen von Teilzeitmitarbeitenden respektive die korrekte Berücksichtigung von Ein- und Austritten während des Jahres.
    </p>
  </div>
);

const fr = (
  <div>
    <p>Cet indicateur mesure le chiffre d’affaires moyen généré par un employé. Le calcul se fait comme suit :</p>
    <BlockMath>{getLatexString("Chiffre d'affairesgénéré", "Équivalents temps plein")}</BlockMath>
    <p className="sia-padding-01-bottom">Les apprentis sont pondérés avec un facteur 15 %.</p>
    <p>
      Les équivalents temps plein sont calculés sur la base des temps de travail contractuels saisis. Cette méthode de calcul permet de tenir compte
      correctement des employés à temps partiel ainsi que des entrées et sorties en cours d’année.
    </p>
  </div>
);

const it = (
  <div>
    <p>Questo indicatore serve a determinare il fatturato medio realizzato da un collaboratore. Questo indicatore è calcolato come segue:</p>
    <BlockMath>{getLatexString("Cifra d'affari generata", "N. posti di lavoro a tempo pieno")}</BlockMath>
    <p className="sia-padding-01-bottom">Gli apprendisti sono ponderati al 15%.</p>
    <p>
      Gli equivalenti a tempo pieno sono stati calcolati in base al tempo di presenza previsto rilevato. Questo metodo di calcolo permette di
      includere accuratamente i collaboratori a tempo parziale come pure di tenere correttamente conto delle entrate e delle uscite di servizio
      durante l'anno.
    </p>
  </div>
);

const en = (
  <div>
    <p>This key figure is for determining how much turnover an employee generates on average. It is calculated as follows:</p>
    <BlockMath>{getLatexString("Revenue per full-time position", "Number of full-time positions")}</BlockMath>
    <p className="sia-padding-01-bottom">Trainees are weighted at 15%.</p>
    <p>
      The full-time positions were calculated on the basis of the recorded nominal time worked. This calculation method enables accurate inclusion of
      part-time employees and correct consideration of new hires and departures during the year.
    </p>
  </div>
);

let text = {
  de,
  fr,
  it,
  en,
};

export default text;
